/**
 * @generated SignedSource<<3a3a3f88ae13bef65d9d8a04e1a7d745>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type appCalendar_viewer$data = {
  readonly id: string;
  readonly company: {
    readonly id: string;
    readonly calendarEnabled: boolean | null;
    readonly calendarApiEnabled: boolean | null;
    readonly outlookCalendarApiEnabled: boolean | null;
  } | null;
  readonly " $fragmentType": "appCalendar_viewer";
};
export type appCalendar_viewer$key = {
  readonly " $data"?: appCalendar_viewer$data;
  readonly " $fragmentSpreads": FragmentRefs<"appCalendar_viewer">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
};
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "appCalendar_viewer",
  "selections": [
    (v0/*: any*/),
    {
      "alias": null,
      "args": null,
      "concreteType": "Company",
      "kind": "LinkedField",
      "name": "company",
      "plural": false,
      "selections": [
        (v0/*: any*/),
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "calendarEnabled",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "calendarApiEnabled",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "outlookCalendarApiEnabled",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Viewer",
  "abstractKey": null
};
})();

(node as any).hash = "378aedbf59dd58107b3c4a9fcd026c48";

export default node;
